import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// eslint-disable-next-line no-unused-vars
import localizationHelper from "./plugins/localizationHelper";
import auth from "./auth/msal-authprovider.js";
import { setPageTitle } from "@/util/pageTitle";

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
});

const updatePageTitle = () => {
  setPageTitle(store.state.qfsRegion);
};

// Update title whenever qfsRegion changes
store.watch(state => state.qfsRegion, updatePageTitle);

// Update title whenever menu is changed
store.watch(state => state.appBar.breadcrumbs, updatePageTitle, { deep: true });

auth.initialize().then(() => {
  router.onReady(() => {
    updatePageTitle();
    app.$mount("#app");
  });
});
